import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import {
  ENGINE_TYPES,
  INPUT_URL_TYPE,
  INPUT_WEBCAM_TYPE,
  INPUT_TYPES,
  INPUT_DECKLINK_TYPE,
  QUICKSTREAM_METHOD_V2,
  INPUT_HLS_SELECTOR,
} from "../lib/utils/constants";

import { selectors as NODE_CHANNEL_SELECTORS } from "../ducks/nodeChannels";

function useNodeChannelConfig() {
  const { id: channelId } = useParams();
  const channelConfig = useSelector((state) => NODE_CHANNEL_SELECTORS.getNodeChannelConfig(state, channelId));

  const isInput = channelConfig?.mainInput || channelConfig?.liveSource?.mainInput;
  const isBackup = channelConfig?.backupInput;

  const isMainQSMethod = !!(channelConfig?.mainInput?.inputStreamCfg?.type === QUICKSTREAM_METHOD_V2.inQSDirect.value);

  const mainInputConfig = channelConfig?.mainInput || channelConfig?.liveSource?.mainInput;
  const backupInputConfig = channelConfig?.backupInput || channelConfig?.liveSource?.backupInput;
  const isMainInputURLType = mainInputConfig?.type === INPUT_URL_TYPE.value;

  const isMainInputWebcamType = mainInputConfig?.type === INPUT_WEBCAM_TYPE.value;
  const isInputRTMPTypeSelected = mainInputConfig?.type === INPUT_TYPES.inputRtmp.value;
  const isMainInputDecklinkType = mainInputConfig?.type === INPUT_DECKLINK_TYPE.value;
  const isInputRTPTypeSelected = mainInputConfig?.type === INPUT_TYPES.inputMpegtsOverRtp.value;
  const isInputNDITypeSelected = mainInputConfig?.type === INPUT_TYPES.inputNdi.value;
  const isInputHLSTypeSelected = mainInputConfig?.type === INPUT_HLS_SELECTOR.value;

  const isBackupInputURLType = channelConfig?.backupInput?.type === INPUT_URL_TYPE.value;
  const isBackupInputWebcamType = channelConfig?.backupInput?.type === INPUT_WEBCAM_TYPE.value;
  const isBackupInputRTMPTypeSelected = channelConfig?.backupInput?.type === INPUT_TYPES.inputRtmp.value;
  const isBackupInputDecklinkType = channelConfig?.backupInput?.type === INPUT_DECKLINK_TYPE.value;
  const isBackupInputRTPTypeSelected = channelConfig?.backupInput?.type === INPUT_TYPES.inputMpegtsOverRtp.value;
  const isBackupInputNDITypeSelected = channelConfig?.backupInput?.type === INPUT_TYPES.inputNdi.value;

  const isDirectInput = !!channelConfig?.input;
  const isEngineDirect = channelConfig?.type === ENGINE_TYPES.DIRECT;
  const isEngineTranscoding = channelConfig?.type === ENGINE_TYPES.TRANSCODING;
  const isEnginePlayout = channelConfig?.type === ENGINE_TYPES.PLAYOUT;
  const outputs = channelConfig?.outputs || [];

  const fileSource = channelConfig?.fileSource;
  const cg = channelConfig?.cg;
  const other = channelConfig?.other;
  const subtitles = channelConfig?.subtitles;
  const scte = channelConfig?.scte;
  const monitoring = channelConfig?.monitoring;
  const timecode = channelConfig?.timecode;
  const asRun = channelConfig?.asRun;

  const globalAudioFormatsMaxChannels = channelConfig?.globalAudioFormats?.[0]?.channels;

  return {
    isInput,
    isBackup,
    isMainQSMethod,
    isMainInputURLType,
    isMainInputWebcamType,
    isInputRTMPTypeSelected,
    isMainInputDecklinkType,
    isInputRTPTypeSelected,
    isInputHLSTypeSelected,
    isInputNDITypeSelected,
    isBackupInputURLType,
    isBackupInputWebcamType,
    isBackupInputRTMPTypeSelected,
    isBackupInputDecklinkType,
    isBackupInputRTPTypeSelected,
    isBackupInputNDITypeSelected,
    channelConfig,
    isDirectInput,
    isEngineDirect,
    isEngineTranscoding,
    isEnginePlayout,
    mainInputConfig,
    backupInputConfig,
    outputs,
    fileSource,
    cg,
    other,
    subtitles,
    scte,
    monitoring,
    timecode,
    globalAudioFormatsMaxChannels,
    asRun,
  };
}

export default useNodeChannelConfig;
